import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OKGeneric } from '../../models';
import { getAssistantResponseQueryParamsSchema } from '../../models/ai/models.ai_agent';

extendZodWithOpenApi(z);
const c = initContract();

export const apiAiAgentRoute = c.router({
  getAssistantResponse: {
    method: 'GET',
    path: `/1.0/agent`,
    summary: 'Get agent response',
    description: 'Get agent response',
    query: getAssistantResponseQueryParamsSchema,
    responses: {
      200: OKGeneric,
    },
  },
});
